import api from '@/api/index'
import * as types from './mutation-types'

export const showToastMessage = ({ commit }, response) => {
  commit(types.SHOW_TOAST_MESSAGE, { response })
}

export const setReportData = ({ commit }, response) => {
  commit(types.SET_REPORT_DATA, { response })
}

export const getMenuList = ({ commit }, response) => {
  return new Promise((resolve, reject) => {
    // 로그인하지 않은 사용자에게 보일 메뉴 목록을 불러온다.
    api.getMenuList(response => {
      if (response.error) {
        reject(Error(response))
      } else {
        commit(types.SET_MENU_LIST, { response })
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/actions.js